export default "__VITE_ASSET__CZz5cpoS__"